<template>
  <div id="search-hospital">
    <b-container fluid class="text-left">
      <b-row>
        <b-col class="col-12 p-1">
          <b-form>
            <b-form-group>
              <multiselect
                v-model="searchHospitalInput"
                style="min-width: 200px;"
                :tabindex="-1"
                :options="hospital"
                label="name"
                track-by="id"
                select-label=""
                deselect-label="✖"
                selected-label=""
                placeholder="สถานพยาบาล"
                class="input-search"
                @close="searchHospital"
              />
            </b-form-group>
            <b-form-group
              id="hospital-address-group"
              label="ที่อยู่ *"
              label-for="hospital-address"
              class="input-search"
            >
              <b-form-textarea
                id="hospital-address"
                v-model="hospitalAddressInput"
                rows="3"
                max-rows="6"
              />
            </b-form-group>
            <b-form-group
              id="hospital-phone-number-group"
              label="เบอร์โทรศัพท์ *"
              label-for="hospital-phone-number"
              class="input-search"
            >
              <b-form-input
                id="hospital-phone-number"
                v-model="hospitalPhoneNumberInput"
                trim
              />
            </b-form-group>
          </b-form>
        </b-col>
      </b-row>
      <!--            <b-row class="mt-5">-->
      <!--                <b-col class="col-12">-->

      <!--                    <b-form-group-->
      <!--                            id="hospital-name-group"-->
      <!--                            label="ชื่อลูกค้า *"-->
      <!--                            label-for="hospital-name"-->
      <!--                            class="input-search"-->
      <!--                    >-->
      <!--                        <b-form-input-->
      <!--                                id="hospital-name"-->
      <!--                                v-model="hospitalNameInput"-->
      <!--                                trim-->
      <!--                        />-->
      <!--                    </b-form-group>-->
      <!--                </b-col>-->
      <!--            </b-row>-->
      <!--            <b-row>-->
      <!--                <b-form-group-->
      <!--                    id="hospital-address-group"-->
      <!--                    label="ที่อยู่ *"-->
      <!--                    label-for="hospital-address"-->
      <!--                    class="input-search"-->
      <!--                >-->
      <!--                    <b-form-textarea-->
      <!--                        id="hospital-address"-->
      <!--                        v-model="hospitalAddressInput"-->
      <!--                        rows="3"-->
      <!--                        max-rows="6"-->
      <!--                    />-->
      <!--                </b-form-group>-->
      <!--            </b-row>-->
      <!--            <b-row>-->
      <!--                <b-form-group-->
      <!--                    id="hospital-phone-number-group"-->
      <!--                    label="เบอร์โทรศัพท์ *"-->
      <!--                    label-for="hospital-phone-number"-->
      <!--                    class="input-search"-->
      <!--                >-->
      <!--                    <b-form-input-->
      <!--                        id="hospital-phone-number"-->
      <!--                        v-model="hospitalPhoneNumberInput"-->
      <!--                        trim-->
      <!--                    />-->
      <!--                </b-form-group>-->
      <!--            </b-row>-->
    </b-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "SearchHospitalCashAddDocumentComponent",
  props: {
    hospitalName: {
      type: String,
    },
    hospitalAddress: {
      type: String,
    },
    hospitalPhoneNumber: {
      type: String,
    },
    hospitalInput: {
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      hospital: "Hospital/getAll",
    }),
    searchHospitalInput: {
      get() {
        return this.hospitalInput;
      },
      set(val) {
        this.$emit("update:hospitalInput", val);
      },
    },
    hospitalNameInput: {
      get() {
        return this.hospitalName;
      },
      set(val) {
        this.$emit("update:hospitalName", val);
      },
    },
    hospitalAddressInput: {
      get() {
        return this.hospitalAddress;
      },
      set(val) {
        this.$emit("update:hospitalAddress", val);
      },
    },
    hospitalPhoneNumberInput: {
      get() {
        return this.hospitalPhoneNumber;
      },
      set(val) {
        this.$emit("update:{", val);
      },
    },
  },
  data() {
    return {
      // searchHospitalInput: "",
    };
  },
  methods: {
    ...mapActions({
      searchHospitalName: "Hospital/searchHospitalName",
    }),
    async searchHospital() {
      // if (this.searchHospitalInput !== "") {
      //   console.log(this.searchHospitalInput)
      //     let result = await this.searchHospitalName({
      //         name: this.searchHospitalInput.name
      //     });
      //
      //     if (result) {
      //         this.hospitalNameInput = result.name;
      //         this.hospitalAddressInput = result.fullAddress;
      //         this.hospitalPhoneNumberInput = result.phone;
      //     }
      // }
    },
  },
  watch: {
    hospitalNameInput(newVal, oldVal) {
      this.$emit("update:hospitalName", newVal);
    },
    hospitalAddressInput(newVal, oldVal) {
      this.$emit("update:hospitalAddress", newVal);
    },
    hospitalPhoneNumberInput(newVal, oldVal) {
      this.$emit("update:hospitalPhoneNumber", newVal);
    },
  },
};
</script>

<style lang="scss" scoped>
#search-hospital {
  border: 0.5px solid #ddd;
}

.search-btn {
  border-left: none;
  background-color: transparent;
}
.input-search {
  /*width: 15rem;*/
}
</style>
